export default __webpack_public_path__ + "static/hn-55100a090c4381b69e10d53d5019c843.svg";